import { render, staticRenderFns } from "./ToggleSolicitacaoMovimentacao.vue?vue&type=template&id=5d1da8f2"
import script from "./ToggleSolicitacaoMovimentacao.vue?vue&type=script&lang=js"
export * from "./ToggleSolicitacaoMovimentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports